import React from 'react';
import { connect } from 'react-redux';
import FilterWrapper from '../../../../components/Common/FilterWrapper';
import InputWrapper from '../../../../components/Common/InputWrapper';
import NowSelect from '../../../../components/Common/NowSelect';
import FromToDatePicker from '../../../../components/Common/FromToDatePicker';
import {
  EnumOrderMerchantToolFilter,
  EnumPage,
  EnumToggleType,
  genEnumToOption,
} from '../../../../constants/enum';
import { trans } from '../../../../localization/index';
import { getDate } from '../../../../utils/utils';
import NowInput from '../../../../components/Common/NowInput';
import NowCheckbox from '../../../../components/Common/NowCheckbox';
import { getExtendsOrderTableInfo, getListIds } from '../actions';
import { changeFilters } from '../../../../redux/genericAction';

const ALL_MERCHANT_OPTION = {
  value: 0,
  label: trans('mod_all_restaurant'),
};

class TableManagementFilter extends React.Component {
  orderGroupStatus = genEnumToOption(EnumOrderMerchantToolFilter);
  merchantOptions = [
    ALL_MERCHANT_OPTION,
    ...this.props.merchantTableInfos.map(merchantData => ({
      value: merchantData.id,
      label: merchantData.name,
      data: merchantData,
    }))
  ];

  handleChangeMerchant = value => {
    const {
      filters,
      handleChangeFiltersConnect,
      handleSearchOrder,
    } = this.props;
    const { merchant } = filters;

    if (value === null || value.value !== merchant.value) {
      handleChangeFiltersConnect('merchant', value || ALL_MERCHANT_OPTION);
      handleSearchOrder();
    }
  };

  handleSearchToday = () => {
    const { handleChangeFiltersConnect, handleSearchOrder } = this.props;
    handleChangeFiltersConnect('fromDate', getDate());
    handleChangeFiltersConnect('toDate', getDate());
    handleSearchOrder();
  };

  handleChangeOrderCode = evt => {
    const { handleChangeFiltersConnect } = this.props;
    const { value } = evt.target || {};
    handleChangeFiltersConnect('orderCode', value.trim());
  };

  handleChangePhone = evt => {
    const { handleChangeFiltersConnect } = this.props;
    const { value } = evt.target || {};
    handleChangeFiltersConnect('phone', value.trim());
  };

  handleKeyPress = event => {
    const { handleSearchOrder } = this.props;
    if (event.key === 'Enter') {
      handleSearchOrder();
    }
  };

  handleChangeShowAllFilters = value => {
    const {
      handleChangeFiltersConnect,
      getExtendsOrderTableInfoConnect,
    } = this.props;
    handleChangeFiltersConnect('isShowTotal', value);
    if (value) {
      getExtendsOrderTableInfoConnect();
    }
  };

  render() {
    const {
      filters,
      handleChangeFiltersConnect,
      handleSearchOrder,
      getExcelFile,
      changeFilterStatus,
      toggleAutoReload,
    } = this.props;
    const {
      merchant,
      fromDate,
      toDate,
      status,
      orderCode,
      isShowTotal,
      phone,
      isAutoReload,
    } = filters;

    return (
      <FilterWrapper>
        <InputWrapper label={trans('mtn_filter_find_order_code')} width={200}>
          <NowInput
            value={orderCode}
            onChange={this.handleChangeOrderCode}
            name="orderCode"
            placeholder={trans('mtn_input_order_code')}
            onKeyPress={this.handleKeyPress}
          />
        </InputWrapper>
        <InputWrapper label={trans('mtn_filter_find_phone')} width={200}>
          <NowInput
            value={phone}
            onChange={this.handleChangePhone}
            name="phone"
            placeholder={trans('mtn_input_phone')}
            onKeyPress={this.handleKeyPress}
          />
        </InputWrapper>
        <InputWrapper label={trans('mtn_restaurant_list')} width={300}>
          <NowSelect
            value={merchant}
            options={this.merchantOptions}
            isClearable
            onChange={this.handleChangeMerchant}
          />
        </InputWrapper>
        <InputWrapper label={trans('mtn_filter_status')} width={200}>
          <NowSelect
            value={status}
            options={this.orderGroupStatus}
            onChange={changeFilterStatus}
            isClearable={false}
          />
        </InputWrapper>
        <InputWrapper label={trans('mtn_filter_time')} width={300}>
          <FromToDatePicker
            fromDate={fromDate}
            toDate={toDate}
            handleChangeFromDate={date =>
              handleChangeFiltersConnect('fromDate', date)
            }
            handleChangeToDate={date =>
              handleChangeFiltersConnect('toDate', date)
            }
          />
        </InputWrapper>
        {status.value === EnumOrderMerchantToolFilter.New.id && (
          <InputWrapper width={200}>
            <NowCheckbox
              value={isAutoReload}
              name={trans('auto_reload')}
              onChange={toggleAutoReload}
            />
          </InputWrapper>
        )}
        <InputWrapper>
          <button
            type="button"
            className="btn btn-blue mr-2"
            onClick={handleSearchOrder}
          >
            {trans('search')}
          </button>
          <button
            type="button"
            className="btn btn-green mr-2"
            onClick={this.handleSearchToday}
          >
            {trans('today')}
          </button>
          <button
            type="button"
            className="btn btn-gray border"
            onClick={getExcelFile}
          >
            {trans('mtn_filter_export')}
          </button>
        </InputWrapper>
        <InputWrapper width={200}>
          <NowCheckbox
            value={isShowTotal}
            name={trans('mtn_show_total_info')}
            onChange={evt =>
              this.handleChangeShowAllFilters(evt.target.checked)
            }
          />
        </InputWrapper>
      </FilterWrapper>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getExcelFile: () => dispatch(getListIds(EnumToggleType.ON.id, true)),
  handleChangeFiltersConnect: (name, value) =>
    dispatch(changeFilters(EnumPage.TABLE_MANAGEMENT.id, name, value)),
  getExtendsOrderTableInfoConnect: () => dispatch(getExtendsOrderTableInfo()),
});
export default connect(
  null,
  mapDispatchToProps,
)(TableManagementFilter);



// WEBPACK FOOTER //
// ./foody/src/pages/Table/TableManagement/components/TableManagementFilter.jsx